<template>
    <div class="project-sloth">
        <img class="project-sloth-image" :src="image"
          alt="title">
        <h4 class="project-sloth-name">
            {{title}}
        </h4>

        <span class="service-rendered" v-for="(service, key) in services" :key="key">
            {{ service }}
        </span>
        <p class="project-sloth-description">
            {{description}}
        </p>
      </div>
</template>

<script>
export default {
  name: "WorkItem",
  props: {
    title: String,
    image: String,
    description: String,
    services: Array,
  }
};
</script>